const specialInnerCodeMap = {
    facialError: 11005,
    garbageDetection: 10009,
    npcImportFileError: 12000,
    npcImportFileTemplateError: 12001,
    importFileFieldInvalid: 11331,
    bindMobileError: 11103,
    smartUploadError: 11332,
    getCodeFrequent: 40025,
    getCodeFrequentAndLaterTry: 40026,
    activitiesCode: 11102,
    importFileCountsError: 11333,
    importFileHeaderInvalid: 11335,
    registrationIsFull: 11336,
    adoptCountOverflow: 11337,
    importFileFieldRepeat: 11338,
    pullResourceError: 11406,
    totalDurationError: 11408,
    liveStreamPullError: 11800,
    unNoticeError: 11371,
    updateClothError: 11705,
    spaceTimeInvalid: 11902,
    jwtTokenError: 46002,
    jwtTokenTimeOut: 46003,
    loginUnAuth: 11100,
    loginTokenExpired: 11104,
    loginPermissionDenied: 11105,
    loginTokenNotFoundUser: 11106, // 登录 Token not found user
};
const specialRbacInnerCodeMap = {
    rbacUnAuthenticate: 40304,
    rbacWxLoginUnAuthorized: 40321,
    rbacActivationPageInvalid: 40334,
    rbacThirdEmailHasRegister: 40335,
    rbacThirdEmailNotRegister: 40336,
    rbacThirdEmailCodeError: 40337, // 登录密码错误
};

export { specialInnerCodeMap, specialRbacInnerCodeMap };
